import React from 'react'
import { useIntl } from 'react-intl'
import { createNgReactBridgeDirective } from '../../react-bridge'
import { EmailDomainsQuery } from '../../../components/security/email-domains-query'
import { SendToEmailModal } from 'contrastBase/Modals'

function ReactSendToEmailDialog({
  organizationID,
  isOpen,
  onClose,
  labelTranslationId,
  sendItems
}) {
  const { formatMessage } = useIntl()

  if (typeof organizationID !== 'string') {
    throw new Error('organizationID is required')
  }

  return (
    <EmailDomainsQuery organizationID={organizationID}>
      {({ domains }) => (
        <SendToEmailModal
          isOpen={isOpen}
          onClose={onClose}
          title={formatMessage({ id: labelTranslationId })}
          sendItems={sendItems}
          permittedDomains={domains}
        />
      )}
    </EmailDomainsQuery>
  )
}

export const reactSendToEmailDialog = createNgReactBridgeDirective(
  'reactSendToEmailDialog',
  [],
  ReactSendToEmailDialog,
  ['organizationID', 'isOpen', 'onClose', 'labelTranslationId', 'sendItems']
)
